/* =========================================================
   BR STUDIO — fx.js  (premium motion layer)
   Shared by the HTML prototype AND the live Shopify theme.
   Pure vanilla JS, progressive enhancement, reduced-motion safe.
   Idempotent: safe to load alongside chrome.js / theme.js.
   ========================================================= */
(function () {
  'use strict';
  if (window.__brfx) return;            // guard against double-init
  window.__brfx = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll progress bar ---------- */
  function scrollProgress() {
    if (reduce) return;
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    document.body.appendChild(bar);
    var tick = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (h.scrollTop || window.pageYOffset) / max : 0;
      bar.style.width = (pct * 100).toFixed(2) + '%';
    };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    tick();
  }

  /* ---------- Count-up numerals ---------- */
  function countUp() {
    var nodes = document.querySelectorAll('.hero-meta .num, .artist-meta .val, [data-count]');
    if (!nodes.length) return;
    var nowYear = new Date().getFullYear() + 1;

    var animate = function (el) {
      var raw = (el.textContent || '').trim();
      var m = raw.match(/^(\D*)(\d[\d,]*)(\D*)$/);   // single number group only
      if (!m) return;
      var prefix = m[1], suffix = m[3];
      var target = parseInt(m[2].replace(/,/g, ''), 10);
      if (isNaN(target)) return;
      if (target > 1900 && target <= nowYear) return; // leave years alone
      el.classList.add('fx-count');
      if (reduce) return;
      var dur = 1400, start = null;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);          // easeOutCubic
        var val = Math.round(target * eased);
        el.textContent = prefix + val.toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target.toLocaleString() + suffix;
      };
      requestAnimationFrame(step);
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Magnetic buttons ---------- */
  function magnetic() {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    var MAX = 8;
    document.querySelectorAll('.btn--primary').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        btn.style.transform = 'translate(' + (dx * MAX).toFixed(1) + 'px,' + (dy * MAX).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Cursor spotlight on cards ---------- */
  function spotlight() {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    var sel = '.svc, .dprod, .test, .work-card, .video-card, .archive-card';
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest(sel);
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Kinetic mask reveal on section headings ---------- */
  function maskHeadings() {
    var targets = document.querySelectorAll('.section-head .h2, [data-fx-mask]');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (h) {
      if (h.querySelector('.fx-mask__i')) return;       // already wrapped
      var inner = document.createElement('span');
      inner.className = 'fx-mask__i';
      while (h.firstChild) inner.appendChild(h.firstChild);
      h.appendChild(inner);
      h.classList.add('fx-mask');
      // protect script-font descenders from the overflow clip
      h.style.paddingBottom = '0.15em';
      h.style.marginBottom = '-0.15em';
      if (reduce) { h.classList.add('in-view'); return; }
      io.observe(h);
    });
  }

  function init() {
    scrollProgress();
    countUp();
    magnetic();
    spotlight();
    maskHeadings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
